import styled from 'styled-components';
import Button from 'shared/ui/Button';
import BaseCancelButton from 'shared/ui/CancelButton';

export const ButtonsContainer = styled.div`
display: flex;
justify-content: flex-end;
margin-top: 34px;
`;
ButtonsContainer.displayName = 'ButtonsContainer';

export const ConfirmButton = styled(Button)`
`;
ConfirmButton.displayName = 'ConfirmButton';

export const CancelButton = styled(BaseCancelButton)`
  margin-right: 10px;
`;
CancelButton.displayName = 'CancelButton';
